import { apiGet } from './http-client';

export type SuperadminOrgOption = {
  id: number;
  name: string;
  slug: string;
};

type RawList = {
  items?: unknown;
  total?: unknown;
};

function parseItem(raw: unknown): SuperadminOrgOption | null {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const o = raw as Record<string, unknown>;
  if (typeof o.id !== 'number' || !Number.isFinite(o.id) || o.id <= 0) return null;
  if (typeof o.name !== 'string' || typeof o.slug !== 'string') return null;
  return { id: o.id, name: o.name, slug: o.slug };
}

/**
 * GET /api/v1/superadmin/organizations — список студий для выбора суперадмином.
 * Заголовок выбранной студии не отправляем: нужен глобальный список.
 */
export async function fetchSuperadminOrganizations(
  accessToken: string,
  query?: string,
  signal?: AbortSignal
): Promise<SuperadminOrgOption[]> {
  const q: Record<string, string | number> = { limit: 50, offset: 0 };
  const trimmed = query?.trim();
  if (trimmed) q.q = trimmed;
  const raw = await apiGet<RawList | unknown[]>(
    '/api/v1/superadmin/organizations',
    q,
    { accessToken, skipImpersonation: true, signal }
  );
  const items = Array.isArray(raw) ? raw : Array.isArray(raw?.items) ? raw.items : [];
  return items.map(parseItem).filter((x): x is SuperadminOrgOption => x != null);
}
